/**
 * Paused-gas HEA lead-only cohort — TEMPORARY (SOF-1341)
 *
 * Mass Save availability is paused for Eversource gas customers on the MA HEA
 * path, so instead of blocking them at the Eligibility step they complete the
 * whole form and we capture a LEAD rather than an appointment. Mechanically
 * identical to CAP HEA: ContactInfo becomes the submit step, the Schedule step
 * is skipped, and Success shows dedicated copy.
 *
 * Columbia Gas was folded into the same cohort — Eversource acquired Columbia
 * Gas (see config.columbiaGasZipCodes), so the pause covers that book of
 * business too. The name is kept for continuity; the whole file is temporary.
 *
 * Membership is by the provider the customer SELECTED, not by derived
 * territory: picking National Grid in a Columbia Gas zip still schedules
 * normally, even though getOpenings.js sends program=ColumbiaGas for it.
 *
 * See isCapHeaCustomer.js — keep the two in sync.
 *
 * CAP HEA takes precedence in the UI: those customers already skip Schedule and
 * get the SCSC copy, so they are excluded here to keep the two cohorts mutually
 * exclusive on the Success page. They are still flagged for Salesforce — the
 * payload marker in submitData.js is deliberately NOT gated on this predicate.
 *
 * DELETE THIS FILE and its call sites when scheduling resumes (target: end of
 * November). Call sites: App.jsx, goNextStep.js, Success.jsx, submitData.js.
 */
export const PAUSED_GAS_PROVIDERS = ['Eversource', 'Columbia Gas']

const isEversourceGasLead = (values = {}) =>
  values.path === 'hea' &&
  PAUSED_GAS_PROVIDERS.includes(values.gasProvider) &&
  values.paymentAssistance !== 'yes'

export default isEversourceGasLead
